const selector = {
  btnComplaintModal: ".js_btn_complaint",
  btnObjectionModal: ".js_btn_objection",
  complaintModal: "#history_complaint_modal",
  objectionModal: "#history_objection_modal",
  objectionNotification: "#history_objection_notification",
  inputComplaintRequestId: "#complaint_request_id",
  inputDate: ".date",

  inputDateFrom: "#filter_date_from",
  inputDateTo: "#filter_date_to",
  btnHistoryExportExcel: ".js_btn_export_excel",
  btnHistoryExportPdf: ".js_btn_export_pdf",

  ddlBank: '#customer_bank_name',
  accountZr2: '#account_zr_2',
  accountZr3: '#account_zr_3',
  bankUniqueNumber: '#bank-unique-number',
  countryTab: '.country-history-tab'
};

export { selector };
